import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SupportService } from 'src/app/rest_services/msHelpServices/support.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
import { UserService } from 'src/app/rest_services/user.service';
@Component({
  selector: 'app-support-detail',
  templateUrl: './support-detail.component.html',
  styleUrls: ['./support-detail.component.css']
})
export class SupportDetailComponent implements OnInit {

  detailLoading: boolean = true;
  ticket: any = { };
  userRole: any;
  editingNote: any = null;
  newNoteContent: string = '';
  newJiraNumber: string = '';
  newComment: string = '';
  newFileName: string = '';
  newFileSize: string = '';
  newFileType: string = '';
  newFileBase64: string = '';
  editingJiraNumber: boolean = false;
  editingComment: boolean = false;
  selectedFile: any;
  editingStatus: boolean = false;
  historyLoading: boolean = false;

  creator: any = { creatorFullName: '', creatorEmail: '' };
  notes:any[] = [];
  id: any;
  ticketHistory : any[] = [];
  constructor(
    private route: ActivatedRoute,
    public sanitizer: DomSanitizer,
    private userService : UserService,
    private supportService : SupportService,
    private msSurvey : SurveyService
  ) { }

  fullname: any = '';
  ngOnInit(): void {

    const ticketId = this.route.snapshot.paramMap.get('id');
    if (ticketId) {
      this.id = ticketId;
      this.loadTicketDetails(ticketId);
    }
    
    this.fullname =localStorage.getItem("fullname") || sessionStorage.getItem("fullname");
    this.userRole = localStorage.getItem("role") || sessionStorage.getItem("role");

  }

  loadTicketDetails(ticketId: string) {
    this.detailLoading = true;
    this.supportService.getRequestDetail(ticketId).subscribe(
      (response: any) => {
        if (response.status === '200') {
          this.ticket = response.ticket;
          this.fetchCreator(this.ticket);
          this.fetchRequestor(this.ticket);
          if (this.ticket.attachments) {
            this.ticket.supportAttach = [];
            this.ticket.demandAttach = [];
            // this.notes = this.ticket.comments.sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
            this.ticket.attachments.forEach((attachment: any) => {
              if (attachment.addedByRole === 'support') {
                this.ticket.supportAttach.push(attachment);
              } else {
                this.ticket.demandAttach.push(attachment);
              }
            });
          }
          this.notes = this.ticket.comments.sort((a: any, b: any) => {
            return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
          });
          this.detailLoading = false;
        } else {
          console.error('Failed to load ticket details');
          this.detailLoading = false;
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
        this.detailLoading = false;
      }
    );
  }

  fetchCreator(ticket : any) {
    const userId = ticket.createdBy;
      this.userService.getUserFilteredData(userId, ['fullName', 'email','companyLogo']).subscribe(
        (userData: any) => {
          if (userData) {
            ticket.creator = userData.connected_user.user_fullname;
            ticket.companyLogo = userData.connected_user.company_logo;
            this.creator.creatorFullName = userData.connected_user.user_fullname;
            this.creator.creatorEmail = userData.connected_user.user_email; 
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
  }

  fetchRequestor(ticket : any) {
    const userId = ticket.requestedBy; // Assuming userId is the user UUID
      this.userService.getUserFilteredData(userId, ['fullName']).subscribe(
        (userData: any) => {
          if (userData) {
            ticket.requestor = userData.connected_user.user_fullname;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
  }

  fetchUser(list : any) {
    list.forEach((history: any) => {
      const userId = history.updatedBy; 
      this.userService.getUserFilteredData(userId, ['fullName','avatar']).subscribe(
        (userData: any) => {
          if (userData) {
            history.avatar = userData.connected_user.user_avatar;
            history.user = userData.connected_user.user_fullname;
          }
        },
        (error: any) => {
          console.error('Error fetching user data:', error);
          // Handle error if needed
        }
      );
    });
  }
  deleteFile(fileArray: any, index: number): void {
    fileArray.splice(index, 1);
  }

  noteLoad : boolean = false;
  addNote(): void {
    if (this.newNoteContent.trim()) {
      this.noteLoad = true;
      const formData = new FormData();
      formData.append('ticketId', this.ticket.uuid);
      formData.append('commentText', this.newNoteContent);
      formData.append('creatorEmail', this.creator.creatorEmail);
      formData.append('creatorFullName', this.creator.creatorFullName);
  
      const formattedDate = this.formatDate(new Date());
      this.supportService.updateTicket(formData).subscribe(
        (response: any) => {
          if (response.status === '200') {
            this.noteLoad = false;
            const newNote = {
              id: this.notes.length + 1,
              author: this.getRoleUUID(this.userRole),
              text: this.newNoteContent,
              createdAt: formattedDate
            };
            this.notes.push(newNote);
            this.newNoteContent = '';
          } else {
            console.error('Failed to update ticket');
          }
        },
        (error: any) => {
          console.error('There was an error!', error);
        }
      );
    }
  }

  getAuthor(uuid: any): string {  
    switch (uuid) {
      case '3a72a811-86cf-4ea8-b561-9f3cef0fb6e5':
        return 'Support';
      case 'a21aab19-d73e-47db-a61c-d2c1f0c8a251':
        return 'Commercial';
      case 'd8aeff31-284b-11ed-8482-00163ee67c31':
        return 'Assistant';
      case '981dc265-63b8-45ba-b356-befb5a9a6f74':
        return 'Directeur Commercial';
      default:
        return 'unknown';
    }
  }

  getRoleUUID(role: string): string {
    switch (role) {
      case 'support':
        return '3a72a811-86cf-4ea8-b561-9f3cef0fb6e5';
      case 'cmrc':
        return 'a21aab19-d73e-47db-a61c-d2c1f0c8a251';
      case 'asst':
        return 'd8aeff31-284b-11ed-8482-00163ee67c31';
      case 'adm':
        return '981dc265-63b8-45ba-b356-befb5a9a6f74';
      default:
        return 'unknown';
    }
  }
  
  jiraLoad: boolean = false;
  addJiraAndComment(): void {
    if (this.newJiraNumber.trim()) {
      this.jiraLoad = true;
      const formData = new FormData();
      formData.append('ticketId', this.ticket.uuid);
      formData.append('jiraNumber', this.newJiraNumber);
      formData.append('jiraComment', this.newComment);
      formData.append('creatorEmail', this.creator.creatorEmail);
      formData.append('creatorFullName', this.creator.creatorFullName);
  
      this.supportService.updateTicket(formData).subscribe(
        (response: any) => {
          if (response.status === '200') {
            this.jiraLoad = false;
            this.ticket.jiraNumber = this.newJiraNumber;
            this.ticket.jiraComment = this.newComment;
            this.newJiraNumber = '';
            this.newComment = '';
          } else {
            console.error('Failed to update ticket status');
          }
        },
        (error: any) => {
          console.error('There was an error!', error);
        }
      );
    }
  }

  editJiraNumber(): void {
    this.editingJiraNumber = true;
    this.newJiraNumber = this.ticket.jiraNumber;
  }

  saveJiraNumber(): void {
    if (this.newJiraNumber.trim()) {
      this.jiraLoad = true;

      const formData = new FormData();
      formData.append('ticketId', this.ticket.uuid);
      formData.append('jiraNumber', this.newJiraNumber);
      formData.append('creatorEmail', this.creator.creatorEmail);
      formData.append('creatorFullName', this.creator.creatorFullName);
  
      this.supportService.updateTicket(formData).subscribe(
        (response: any) => {
          if (response.status === '200') {
            this.jiraLoad = false;
            this.ticket.jiraNumber = this.newJiraNumber;
            this.editingJiraNumber = false;
          } else {
            console.error('Failed to update ticket status');
          }
        },
        (error: any) => {
          console.error('There was an error!', error);
        }
      );
    }
  }

  showHistory(){
    this.fetchTicketHistory();
    ($('#history') as any).modal('show');
  }
  fetchTicketHistory() {
    this.historyLoading = true;
    this.ticketHistory = [];
    this.supportService.getHistory(this.id);
    this.supportService.historySubject.subscribe(
      (response: any) => {
        if (response.status === '200') {
          this.ticketHistory = response.history;
          this.fetchUser(this.ticketHistory);
          this.historyLoading = false;
        }else if ((response.status === '404') || (response.status === '500')) {
          this.historyLoading = false;
          this.ticketHistory = [];
        }
      }
    );
  }
  editComment(): void {
    this.editingComment = true;
    this.newComment = this.ticket.jiraComment;
  }

  saveComment(): void {
    if (this.newComment.trim()) {
      this.jiraLoad = true;
      const formData = new FormData();
      formData.append('ticketId', this.ticket.uuid);
      formData.append('jiraComment', this.newComment);
      formData.append('creatorEmail', this.creator.creatorEmail);
      formData.append('creatorFullName', this.creator.creatorFullName);
  
      this.supportService.updateTicket(formData).subscribe(
        (response: any) => {
          if (response.status === '200') {
            this.jiraLoad = false;
            this.ticket.jiraComment = this.newComment;
            this.editingComment = false;
          } else {
            console.error('Failed to update ticket status');
          }
        },
        (error: any) => {
          console.error('There was an error!', error);
        }
      );
    }
  }
  hoveredFile: any = null;

  showImage(file: any) {
      file.base64Image = 'data:image/png;base64,' + file.file;
      this.hoveredFile = file;
  }

  attachments: any[] = [];
  hideImage() {
      this.hoveredFile = null;
  }
  selectednewFile: File | null = null;
  handleFileInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.selectednewFile = null;
      return;
    }
    this.attachments = [];
    const file = input.files[0];

    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if (!allowedTypes.includes(file.type)) {
      input.value = '';
      return;
    }
    this.attachments.push(file);
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.newFileBase64 = e.target.result.split(',')[1];
    };
    
    reader.readAsDataURL(file);
    this.selectednewFile = input.files[0];
    this.newFileName = file.name;
    this.newFileSize = (file.size / 1024).toFixed(2) + ' KB';
    this.newFileType = file.type;
  }

  attachLoad: boolean = false;
  addFile(fileArray :any): void {
    if (this.newFileName && this.newFileType && this.newFileBase64) {
      this.attachLoad = true;
      const formData = new FormData();
      formData.append('ticketId', this.ticket.uuid);
      formData.append('creatorEmail', this.creator.creatorEmail);
      formData.append('creatorFullName', this.creator.creatorFullName);
  
      for (let i = 0; i < this.attachments.length; i++) {
        formData.append('attachments', this.attachments[i], this.attachments[i].name);
      }
      this.supportService.updateTicket(formData).subscribe(
        (response: any) => {
          if (response.status === '200') {
            this.attachLoad = false;
            const formattedDate = this.formatDate(new Date());
            const newFile = {
              addedAt: formattedDate,
              fileName: this.newFileName,
              fileType : this.newFileType,
              base64Image: this.newFileBase64,
              file: this.newFileName
            };
            fileArray.push(newFile);
            this.newFileName = '';
            this.newFileType = '';
            this.newFileBase64 = '';
            this.attachments = [];
          } else {
          }
        },
        (error: any) => {
          console.error('There was an error!', error);
        }
      );
    }
  }

  formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  showFileModal(file: any): void {
    const fileType = file.fileType.split('/')[0];
    if (fileType === 'image' || file.fileType === 'application/pdf') {
      this.selectedFile = file;
      if (file.fileType === 'application/pdf') {
        ($('#PDFModal') as any).modal('show');
      } else {
        ($('#fileModal') as any).modal('show');
      }
    }
  }

  downloadFile(file: any): void {
    const link = document.createElement('a');
    link.href = 'data:' + file.fileType + ';base64,' + file.base64Image;
    link.download = file.fileName;
    link.click();
  }
  editStatus(): void {
    this.editingStatus = true;
  }
  statusLoad: boolean = false;
  saveStatus(): void {
    if(this.ticket.status === 'Clos') {
      ($('#surveyModal') as any).modal('show');
    }
    this.updateStatus();
  }

  sendSurvey(): void {
    this.initSurveyVisit();
    ($('#surveyModal') as any).modal('hide');
  }

  updateStatus(){
    this.statusLoad = true;
    const formData = new FormData();
    formData.append('ticketId', this.ticket.uuid);
    formData.append('status', this.ticket.status);
    formData.append('creatorEmail', this.creator.creatorEmail);
    formData.append('creatorFullName', this.creator.creatorFullName);

    this.supportService.updateTicket(formData).subscribe(
      (response: any) => {
        if (response.status === '200') {
          this.statusLoad = false;
          this.editingStatus = false;
        } else {
          console.error('Failed to update ticket status');
        }
      },
      (error: any) => {
        console.error('There was an error!', error);
      }
    );
  }

  initSurveyVisit(){
    const requestBody = {
      uuid_ticket: this.id,
      contact_email: this.creator.creatorEmail,
      contact_fullName: this.creator.creatorFullName,
    };

    this.msSurvey.initSurveyVisit(requestBody);
    this.msSurvey.initSurveyVisitSubject.subscribe(
      ( data: any ) => {
        console.log(data);
      },
      (error: any) => {
      }
    )
  }
}
